export default __webpack_public_path__ + "static/lsa-website-2-mobile-f23af961ea02ad2c161b398330a29a57.jpg";